import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

/**
 * Create a payment request with OxaPay
 * @param {number} amount - Amount to stake
 * @param {string} currency - Currency code (default: USDT)
 * @param {string} description - Description of the payment
 * @param {object} metadata - Additional metadata for the payment
 * @returns {Promise<object>} Payment URL and transaction details
 */
export const createPayment = async (amount, currency = 'USDT', description, metadata = {}) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/pay/create-payment`,
      { amount, currency, description, metadata },
      {
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': process.env.REACT_APP_API_KEY // Optional API key if needed
        }
      }
    );
    console.log(response);
    return response.data;
  } catch (error) {
    console.error('Error creating payment:', error);
    throw new Error(error.response?.data?.error || 'Failed to create payment');
  }
};

/**
 * Get payment status
 * @param {string} transactionId - OxaPay transaction ID
 * @returns {Promise<object>} Payment status
 */
export const getPaymentStatus = async (transactionId) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/pay/status/${transactionId}`,
      {
        headers: {
          'X-API-Key': process.env.REACT_APP_API_KEY // Optional API key if needed
        }
      }
    );
    
    return response.data;
  } catch (error) {
    console.error('Error fetching payment status:', error);
    throw new Error(error.response?.data?.error || 'Failed to fetch payment status');
  }
};

/**
 * Process stake payment using OxaPay
 * @param {number} amount - Amount to stake
 * @param {string} playerAddress - Player's wallet address
 * @param {number} gameId - ID of the game to stake in
 * @returns {Promise<object>} Payment URL and transaction details
 */
export const processStakePayment = async (amount, playerAddress, gameId, genID) => {
  try {
    // Generate a unique callback URL
    const description = `${gameId}-${playerAddress}-${genID}`;
    
    // Create metadata to pass to OxaPay
    const metadata = {
      gameId,
      playerAddress,
      timestamp: new Date().toISOString()
    };
    
    // Create the payment request
    const payment = await createPayment(
      amount,
      'USDT', // Default currency
      description,
      metadata
    );
    
    return payment;
  } catch (error) {
    console.error('Error processing stake payment:', error);
    throw error;
  }
};
